import { render } from "./LiftingReport.vue?vue&type=template&id=83ca76b8&scoped=true"
import script from "./LiftingReport.vue?vue&type=script&lang=js"
export * from "./LiftingReport.vue?vue&type=script&lang=js"

import "./LiftingReport.vue?vue&type=style&index=0&id=83ca76b8&scoped=true&lang=css"

import exportComponent from "/var/www/dev.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83ca76b8"]])

export default __exports__